import { prefixObjectValues as pre } from '../utils';

const prefix = 'aoi-table';

const table = pre(
  {
    area: 'area-',
    deleteBtn: 'delete-btn-',
    row: 'row-',
    specialty: 'description-',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
